module.exports = __webpack_public_path__ + "img/survey_banner_pc.f31479d2.png";